import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/shared/services/login.service';

@Component({
    selector: 'app-login-email',
    templateUrl: './login-email.component.html',
    styleUrls: ['./login-email.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginEmailComponent implements OnInit {

  actionForm: string;
  getToken: boolean = false;
  sendForm: boolean = false
  getError: string = null
  getMessage: string = null
  tokenError: string | null = null

  email: string = '';
  token;

  tokenForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.email, Validators.required]),
  });

  constructor(private _login: LoginService, private route: ActivatedRoute, private router: Router) {
    this.actionForm = _login.actionTokenURL
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['error']) {
        this.getToken = true;
        if (params['email']) {
          this.email = params['email'];
        }
        switch (params['error']) {
          case 'invalid_token':
            this.tokenError = 'Invalid token. Please try again.';
            break;
          case 'too_many_attempts':
            this.tokenError = 'Too many attempts. Please try again later.';
            break;
          case 'missing':
            this.tokenError = 'Email and token are required.';
            break;
          default:
            this.tokenError = 'An error occurred. Please try again.';
        }
      }
    });
  }

  responseSubmit(data) {
    if (data.error) {
      switch (data.msg) {
        case 'Email not found':
          this.getError = 'This user is not created on the system. Please contact your administator'
          break;

        default:
          this.getError = 'Error at generate token'
          break;
      }

      return;
    }

    this.changeView('token');
    this.getMessage = 'Token successfully generated, please check your email'
    return;
  }

  submitForm() {
    this.sendForm = true
    if (!this.getToken) {
      this._login.sendToken(this.tokenForm.value['email']).subscribe(this.responseSubmit.bind(this))
    }
  }

  changeView(view) {
    this.sendForm = false
    this.tokenError = null

    if (view == 'token') {
      this.email = this.tokenForm.value['email'];
      this.getToken = true
    } else {
      this.getToken = false
    }

    this.router.navigate([], { queryParams: {} });
  }

}
